import { useState, useRef, useCallback } from "react";

const debounce = <T extends (...args: unknown[]) => void>(
  fn: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
};

export const useSearchTerm = (debounceDelay = 100) => {
  const [searchTerm, setSearchTerm] = useState("");

  const debouncedSetSearchTerm = useRef(
    debounce((term: string) => {
      setSearchTerm(term);
    }, debounceDelay)
  ).current;

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      debouncedSetSearchTerm(e.target.value);
    },
    [debouncedSetSearchTerm]
  );

  const clearSearch = () => setSearchTerm("");

  return {
    searchTerm,
    setSearchTerm,
    handleSearchChange,
    clearSearch,
  };
};
